import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchUsers, deleteUser } from '../redux/slices/userSlice';
import { RiDeleteBin6Line } from "react-icons/ri";
import moment from 'moment';

const UsersList = () => {
    const dispatch = useDispatch();
    const { users, loading } = useSelector((state) => state.users);

    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState('all'); // all, user, servicemen, admin

    useEffect(() => {
        dispatch(fetchUsers());
    }, [dispatch]);

    const handleDelete = (user) => {

        let message = "Are you sure you want to delete this user?";

        if (user.role === "vendor") {
            message =
                "Are you sure you want to delete this vendor?\n\nDeleting this user will also delete the vendor profile and shop permanently.";
        }

        if (window.confirm(message)) {
            dispatch(deleteUser(user._id));
        }
    };

    const filteredUsers = users
        .filter((user) =>
            (activeTab === 'all' || user.role === activeTab) &&
            (user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.email?.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Newest first

    return (
        <div className='card h-100 p-0 radius-12' style={{ padding: '20px' }}>
            <div className='card-header d-flex flex-column justify-content-start align-items-start mb-3'>
                <div className="d-flex justify-content-between w-100 mb-2">
                    <h6 className='text-dark mb-0'>User List</h6>
                    <input
                        type="text"
                        placeholder="Search by name or email"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ borderRadius: 8, padding: '8px', border: '1px solid #efefef', width: '300px' }}
                    />
                </div>

                {/* Tabs */}
                <div className="d-flex gap-4 mt-2">
                    {['all', 'user', 'vendor', 'admin'].map((role) => (
                        <button
                            key={role}
                            onClick={() => setActiveTab(role)}
                            style={{
                                padding: '8px 16px',
                                borderRadius: 8,
                                border: 'none',
                                cursor: 'pointer',
                                backgroundColor: activeTab === role ? '#f41b3b' : '#efefef',
                                color: activeTab === role ? '#fff' : '#000'
                            }}
                        >
                            {role.charAt(0).toUpperCase() + role.slice(1)}
                        </button>
                    ))}
                </div>
            </div>

            {loading ? (
                <p>Loading users...</p>
            ) : (
                <div className='card-body'>
                    <table className='table table-bordered' style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead className="table-dark" style={{ background: '#f4f4f4' }}>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Role</th>
                                <th>Created At</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user, index) => (
                                    <tr key={user._id}>
                                        <td>{index + 1}</td>
                                        <td>{user.name || '-'}</td>
                                        <td>{user.email || '-'}</td>
                                        <td>{user.phoneNumber || '-'}</td>
                                        <td>{user.role || '-'}</td>
                                        <td>{moment(user.createdAt).format('DD/MM/YYYY')}</td>
                                        <td>
                                            <button
                                                onClick={() => handleDelete(user)}
                                                style={{ color: 'red' }}
                                            >
                                                <RiDeleteBin6Line />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="7" style={{ textAlign: 'center' }}>No users found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default UsersList;
